<template>
    <v-card class="grey lighten-4">
        <v-toolbar dense dark color="green darken-3">
            <v-toolbar-title>Clientes&nbsp;&nbsp;</v-toolbar-title>    
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <v-btn
                        text
                        class="text-none"
                        @click="onNewClient">
                        <v-icon color="white">mdi-account-plus</v-icon>&nbsp;Nuevo Cliente
                    </v-btn>
                    <v-btn
                        text
                        class="text-none"
                        @click="onEditClient"
                        :disabled="this.selectedClient.length === 0">
                        <v-icon color="white">mdi-account-edit</v-icon>&nbsp;Editar Cliente</v-btn>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                text
                                @click="onCancel"
                                v-on="on"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cancelar</span>
                    </v-tooltip>
                </v-toolbar-items>

                <!-- Menú lateral para dispositivos con ventanas chicas: -->
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" class="hidden-md-and-up">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list color="grey lighten-4">
                        <v-list-item @click="onNewClient">
                            <v-list-item-title>
                                <v-icon color="brown darken-1">mdi-account-plus</v-icon>&nbsp; Nuevo Cliente
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="onEditClient">
                            <v-list-item-title>
                                <v-icon color="brown darken-1">mdi-account-edit</v-icon>&nbsp; Editar Cliente
                            </v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item @click="onCancel">
                            <v-list-item-title>
                                <v-icon color="red">mdi-close</v-icon>&nbsp; Cancelar
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>

            <v-card-text>
                <v-container fluid>
                    <v-layout row wrap justify-space-between>
                        <v-flex xs8>
                            <v-text-field
                                :dense="bDense"
                                prepend-icon="mdi-account"
                                label="Cliente"
                                type="text"
                                v-model="clientToSearch"
                                color="green darken-3"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                            <v-text-field
                                :dense="bDense"
                                label="R.F.C."
                                type="text"
                                v-model="rfcToSearch"
                                color="green darken-3"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs3 align-self-center>
                            <v-btn
                                color="green darken-3"
                                class="text-none"
                                text
                                @click="onSearchClient"
                                :disabled = "(clientToSearch === '') && (rfcToSearch === '')"
                                >Buscar cliente
                            </v-btn>
                        </v-flex>
                        <v-flex xs3 align-self-center>
                            <v-btn
                                color="green darken-3"
                                class="text-none"
                                text
                                @click="onCleanFields"
                                :disabled = "(clientToSearch === '') && (rfcToSearch === '')"
                                >Limpiar campos
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout row >
                        <v-flex xs12>
                            <v-data-table
                                readonly
                                fixed-header
                                :headers="clientHeader"
                                :items="clients"
                                item-key="clienteid"
                                v-model="selectedClient"
                                locale="es-MX"
                                hide-default-footer
                                class="elevation-1"
                                :show-select = "clients.length!==0"
                                single-select
                                dense
                                :no-data-text="noClientSearchResult"
                                :items-per-page="clients.length"
                                >
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-layout align-center justify-end row fill-height>
                        <v-flex xs12 sm8 class="text-xs-center text-end">
                            <v-btn
                                color="green darken-3"
                                class="text-none"
                                text
                                @click="onSelect"
                                :disabled="selectedClient.length===0"
                                >Seleccionar Cliente
                            </v-btn>
                            <v-btn
                                color="pink darken-1"
                                class="text-none"
                                text
                                @click="onCancel"
                                >Cancelar
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <!-- Modal para agregar o editar un cliente: *********************************** -->
                        <v-layout v-if="bEdit" row justify-center>
                            <v-dialog
                                v-model="bEdit"
                                persistent
                                max-width="60%"
                            >
                                <v-card class="grey lighten-3">
                                    <v-toolbar dense color="green darken-3" dark flat>
                                        <v-toolbar-title v-if="bNew" class="my-list-title"><v-icon>mdi-account-plus</v-icon> &nbsp; Nuevo cliente &nbsp;</v-toolbar-title>
                                        <v-toolbar-title v-else class="my-list-title"><v-icon>mdi-account-edit</v-icon> &nbsp; Edición de cliente &nbsp;</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    text @click="onCancel" v-on="on"><v-icon>mdi-close-box</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Cancelar</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container pa-2 grid-list-sm fluid>
                                            <v-layout row>
                                                <v-flex xs12 md8>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-account"
                                                        label="Cliente"
                                                        v-model="clientToEdit"           
                                                        color="green darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="R.F.C."
                                                        v-model="rfcToEdit"
                                                        color="green darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onSaveClient"
                                            >OK</v-btn
                                        >

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelEditClient"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar o editar un cliente ********************************************-->
                </v-container>
            </v-card-text>
    </v-card>          
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'clients',
    data() {
        return {
            bDense: false,
            bNew: false,
            bEdit: false,
            rfcToSearch: '',
            clientToSearch: '',
            clientToEdit: '',
            rfcToEdit: '',
            clientToEditID: 0,
            selectedClient: [],
            clientHeader: [
                {
                    text: 'R.F.C.',
                    sortable: true,
                    align: 'left',
                    value: 'rfc',
                },
                {
                    text: 'Cliente',
                    sortable: true,
                    align: 'left',
                    value: 'nombre'
                },
            ],
        };
    },

    created() {

        if (this.id !== 0) //Ya había un cliente antes...
        {
            this.clients = [
                {
                    clienteid: this.id,
                    rfc: this.rfc,
                    nombre: this.cliente
                }
            ];
        }
        else
        {
             this.clients = [];
        }

        console.log("ClientsDlg created, noClientSearchResult = ", this.noClientSearchResult);
        console.log("clients = ", this.clients);
    },

    props: {
        id: Number,
        rfc: String,
        cliente: String
    },

    methods: {
        onSearchClient()
        {
            var clientToSearch = {
                rfc: this.rfcToSearch,
                nombre: this.clientToSearch
            }
            this.$store.dispatch('searchClients', clientToSearch);
        },
        onCleanFields()
        {
            this.rfcToSearch = '';
            this.clientToSearch = '';
            this.clients = [];
        },
        onCancel(){
            this.showClientsDlg = false;
        },
        onSelect(){
            this.client = {
                clienteid: this.selectedClient[0].clienteid,
                rfc: this.selectedClient[0].rfc,
                nombre: this.selectedClient[0].nombre
            };

            this.showClientsDlg = false;

        },
        onNewClient(){
            this.clientToEdit = '';
            this.rfcToEdit = '';
            this.clientToEditID = 0;
            this.bNew = true;
            this.bEdit = true;
        },
        onEditClient(){
            this.clientToEdit = this.selectedClient[0].nombre;
            this.rfcToEdit = this.selectedClient[0].rfc;
            this.clientToEditID = this.selectedClient[0].clienteid;
            this.bNew = false;
            this.bEdit = true;
        },
        onCancelEditClient(){
            this.clientToEdit = '';
            this.rfcToEdit = '';
            this.clientToEditID = 0;
            this.bNew = false;
            this.bEdit = false;
        },
        onSaveClient(){
            if (!this.bNew) //Edición de cliente:
            {
                var i;
                for (i = 0; i < this.clients.length; i ++)
                {
                    if (this.clientToEditID === this.clients[i].clienteid)
                    {
                        this.clients[i].nombre = this.clientToEdit;
                        this.clients[i].rfc = this.rfcToEdit;
                        this.$store.dispatch('editClient', this.clients[i]);
                        break;
                    }
                }
            }
            else //Cliente nuevo:
            {
                this.clients = [];
                var newClient = {
                    clienteid: 0,
                    nombre: this.clientToEdit,
                    rfc: this.rfcToEdit
                }
                //this.clients.push[newClient];
                this.$store.dispatch('newClient', newClient);
            }
            this.clientToEdit = '';
            this.rfcToEdit = '';
            this.bNew = false;
            this.bEdit = false;
        },
    },

    computed: {
        ...mapGetters([
            'waitCursor',
            'userType',
        ]),

        showClientsDlg: {
            get() {
                return this.$store.getters.showClientsDlg;
            },
            set(showClientsDlg){
                this.$store.dispatch('updateShowClientsDlg', showClientsDlg);
            }
        },

        clients: {
            get() {
                return this.$store.getters.clients;
            },
            set(clients){
                this.$store.dispatch('updateClients', clients);
            }
        },

        client: {
            get() {
                return this.$store.getters.client;
            },
            set(client){
                this.$store.dispatch('updateClient', client)
            }
        },

        noClientSearchResult: {
            get() {
                return this.$store.getters.noClientSearchResult;
            },
            set(noClientSearchResult){
                this.$store.dispatch('updateNoClientSearchResult', noClientSearchResult);
            }
        },
    },
};
    

</script>

<style scoped>

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>